
export const CPData = [
    {
        PlatformName: 'LeetCode',
        Ratings: '3.5✨Star(950+ Questions)',
        profileUrl: 'https://leetcode.com/PritamSinghSolanki/',
        imageUrl: 'https://i.ibb.co/6Dr98mB/ltcode.png',
    },
    {
        PlatformName: 'Codeforces',
        Ratings: '1100🐱‍👤',
        profileUrl: 'https://codeforces.com/profile/pritamsinghsolanki212000',
        imageUrl: 'https://github.com/akshitdesai/contest-image-generator/blob/main/CODEFORCES.png?raw=true',
    },
    {
        PlatformName: 'CodeChef',
        Ratings: '3✨Star (1793)',
        profileUrl: 'https://www.codechef.com/users/pritam_2111',
        imageUrl: 'https://github.com/akshitdesai/contest-image-generator/blob/main/CODECHEF.png?raw=true',
    },
    {
        PlatformName: 'GeeksforGeeks',
        Ratings: '300+ Questions🐱‍👓',
        profileUrl: 'https://auth.geeksforgeeks.org/user/pritamsinghsolanki2000/profile',
        imageUrl: 'https://i.ibb.co/DRk6tQR/gfg.png',
    },
    {
        PlatformName: 'Interviewbit',
        Ratings: '100+ Questions🐱‍👓',
        profileUrl: 'https://www.interviewbit.com/profile/pritam_2111',
        imageUrl: 'https://www.linkpicture.com/q/inter.png',
    },
];
